module.exports = __webpack_public_path__ + "static/img/bg_8.6210e5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_8.png
// module id = oQBN
// module chunks = 1